import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 6",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="3" cy="3" r="3" fill="currentColor" />' }
  })
);